// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__DmKw4","badge":"tabs_badge__tEIfz","badge-yellow":"tabs_badge-yellow__MVQ7j","badge-green":"tabs_badge-green__FCH5F","badge-red":"tabs_badge-red__YjILr"};